// extracted by mini-css-extract-plugin
export default {"peliculaCard":"PeliculaCard_peliculaCard__TrkfI","peliculaImage":"PeliculaCard_peliculaImage__nDCEa"};